/**
 * Single Funnelback autocomplete option.
 */

interface FunnelbackSuggestion {
  key: string;
  disp: string;
  disp_t: string;
  wt: string;
  cat: string;
  cat_t: string;
  action: string;
  action_t: string;
}

type Props = {
  suggestion: FunnelbackSuggestion;
  index: number;
  isFocused: boolean;
  baseClassName: string;
  onClick: (suggestion: FunnelbackSuggestion) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLLIElement>, index: number) => void;
  onFocus?: (index: number) => void;
};

const Suggestion = (props: Props) => {
  const {
    suggestion,
    index,
    isFocused,
    baseClassName,
    onClick,
    onKeyDown,
    onFocus,
  } = props;
  return (
    <li
      id={`suggestion-${index}`}
      role="option"
      aria-selected={isFocused}
      tabIndex={0}
      className={`${baseClassName}__item${isFocused ? ` ${baseClassName}__item--focused` : ''}`}
      data-search-value={suggestion.disp}
      onClick={() => onClick(suggestion)}
      onKeyDown={(e) => {
        if (onKeyDown) {
          onKeyDown(e, index);
        }
      }}
      onFocus={() => {
        if (onFocus) {
          onFocus(index);
        }
      }}
    >
      {suggestion.disp}
    </li>
  );
};

export default Suggestion;
export type { FunnelbackSuggestion };
